// extracted by mini-css-extract-plugin
export var content_wrapper = "styles-module--content_wrapper--x22Ro";